// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3874) return "static/chunks/antd-715ec7a0f6f9a50d.js";
	if (chunkId === 6777) return "static/chunks/6777-58ae242f90acdc96.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"525":"ffbe4d2a46fb9219","583":"460629f3f8fec8a1","1680":"757ab02f72b4ee14","3227":"e76a55650107c001","3302":"1ef64962107d9d15","5661":"8941c305cac5b584","6189":"88b6d5b04e8a66c4","6726":"c84a47c55263812a","8212":"d55467cc74309a93","8814":"907e91cbc41bf7c7"}[chunkId] + ".js";
};